module.exports = __webpack_public_path__ + "img/img_side_fire.fc8d7864.png";